import { useEffect, useReducer, useRef } from 'react';
import { useDIContainer } from '@/container/RouteContainerProvider';
import { PinnedTilesStore } from './PinnedTilesStore';

/**
 * Resolves the singleton {@link PinnedTilesStore} and subscribes the calling
 * component to its changes. Mirrors the manual subscribe pattern used by the
 * assist provider — deliberately NOT {@link useViewModel}, whose unmount
 * `dispose()` would clear a shared singleton's listeners.
 */
export function usePinnedTilesStore(): PinnedTilesStore {
    const container = useDIContainer();
    const ref = useRef<PinnedTilesStore | null>(null);
    if (ref.current === null) {
        ref.current = container.resolve(PinnedTilesStore);
    }
    const store = ref.current;
    const [, forceUpdate] = useReducer((count: number) => count + 1, 0);
    useEffect(() => store.subscribe(() => forceUpdate()), [store]);
    return store;
}
